import { z } from "zod";

export const CommissionPhaseFieldsSchema = z.object({
  id: z.number(),
  /** @deprecated use `id` instead */
  commissionPhaseId: z.number(),
  phaseName: z.string(),
  documentSeriesDefinition: z.string(),
  isFirstPhase: z.boolean(),
  stage: z.any(),
  color: z.any(),
  productRequired: z.number(),
  serialCodeRequired: z.number(),
});
export const PartialCommissionPhaseFieldsSchema =
  CommissionPhaseFieldsSchema.deepPartial();

export const CommissionPhaseExtraFieldsSchema = z.object({
  availableTemplates: z.any(),
});
export const PartialCommissionPhaseExtraFieldsSchema =
  CommissionPhaseExtraFieldsSchema.deepPartial();

export const CommissionPhaseSchema = z.intersection(
  CommissionPhaseFieldsSchema,
  CommissionPhaseExtraFieldsSchema
);

export type CommissionPhaseFields = z.infer<typeof CommissionPhaseFieldsSchema>;
export type PartialCommissionPhaseFields = z.infer<
  typeof PartialCommissionPhaseFieldsSchema
>;
export type CommissionPhaseExtraFields = z.infer<
  typeof CommissionPhaseExtraFieldsSchema
>;
export type PartialCommissionPhaseExtraFields = z.infer<
  typeof PartialCommissionPhaseExtraFieldsSchema
>;
export type CommissionPhase = z.infer<typeof CommissionPhaseSchema>;
